import React, { ReactNode } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { SanityExternalLink } from "../../model/common";
import Link from "../Link/Link";

export interface ExternalLinkProps {
  children: ReactNode;
  mark: SanityExternalLink;
}

export const getExternalTo = (
  { alternatives, href }: SanityExternalLink,
  language: string
) => {
  return alternatives?.find(a => a.language === language)?.href ?? href;
};

// Intended for block content rendering. Otherwise just use Link.
const ExternalLink = ({ children, mark }: ExternalLinkProps) => {
  const language = useLanguage();
  const to = getExternalTo(mark, language);
  if (!to) {
    // Just for the sake of draft content, this is an error in the CMS.
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return <a>{children}</a>;
  }
  return <Link to={to}>{children}</Link>;
};

export default ExternalLink;
